import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/site-location";
const name = "SiteLocation";

export const siteLocationApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    ...globalEndpoints(builder, path, name, []),
  }),
});

export const {
  useGetAllSiteLocationQuery,
  useGetByIdSiteLocationQuery,

  useLazyGetAllSiteLocationQuery,
  useLazyCompanyCheckQuery,

  useCreateSiteLocationMutation,
  useUpdateSiteLocationMutation,
  useDeleteSiteLocationMutation,
} = siteLocationApi;
